import collection from './course/collection';
import item from './course/item';

const course = {
  namespaced: true,
  modules: {
    collection,
    item,
  },
};

export default course;
